// removed by extract-text-webpack-plugin
module.exports = {"subheading":"src-components-modules-HeadingCopy-styles----general-module---subheading---2pq_4 fontSize-l lineHeight-copy breakPointS-fontSize-xl breakPointM-fontSize-xxl breakPointM-lineHeight-xxl fontWeight-4 c-slate"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modules/HeadingCopy/styles/general.module.css
// module id = 1470
// module chunks = 157636680307020